import {
  FlatList,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";

import BackArrowIcon from "@assets/svg/BackArrow";
import t from "@constants/localization";
import testIds from "@constants/testIds";
import CloseIcon from "@assets/svg/CloseIcon";
import SearchBar from "@components/SearchBar";
import { useSelector } from "react-redux";
import NoResultsFound from "@assets/svg/NoResultsFound";
import analytics from "@services/analytics";
import { CX_SEARCH_BAR_CLICKED, CX_SEARCHED } from "@constants/analyticsEvents";
import { useDebounce } from "@utils/debounce";
import CustomerCard from "./components/CustomerCard";

const PATH = "screens/Shop/TodaysCustomers";

const ListEmptyComponent = () => {
  return (
    <View style={styles.listEmptyComponentContainer}>
      <NoResultsFound />
      <Text style={styles.noCustomersFound}>
        {t(`${PATH}/noCustomerFound`)}
      </Text>
      <Text style={styles.searchOtherCustomer}>
        {t(`${PATH}/searchOtherCustomer`)}
      </Text>
    </View>
  );
};

const TodaysCustomers = (props) => {
  const { orderedCustomers, notOrderedCustomers } = useSelector(
    ({ shop }) => shop?.stats,
  );
  const [data, setData] = useState([]);
  const [query, setQuery] = useState("");
  const totalCustomers = notOrderedCustomers?.length + orderedCustomers?.length;

  const debouncedQuery = useDebounce(query, 1500);

  useEffect(() => {
    if (query === "") {
      setData([]);
    } else {
      setData(
        [...notOrderedCustomers, ...orderedCustomers].filter((item) => {
          const name = item?.name?.toLowerCase();
          const phoneNumber = item?.user_phone;
          if (
            name?.includes(query.toLowerCase()) ||
            phoneNumber?.includes(query)
          ) {
            return true;
          }
          return false;
        }),
      );
    }
  }, [query, notOrderedCustomers, orderedCustomers, totalCustomers]);

  useEffect(() => {
    if (debouncedQuery !== "") {
      analytics.trackEvent(CX_SEARCHED, {
        screen: "todays_cx",
        search_term: debouncedQuery,
        number_of_results: data.length,
      });
    }
  }, [data?.length, debouncedQuery]);

  const renderItem = ({ item }) => <CustomerCard {...props} data={item} />;
  const renderOrderedCustomers = () => {
    return (
      <View>
        <Text style={styles.sectionHeader}>
          {t(`${PATH}/orderedCustomers`)}
        </Text>
        {orderedCustomers.map((item) => {
          return <CustomerCard {...props} data={item} />;
        })}
      </View>
    );
  };

  const keyExtractor = (item) => item?.user_id;

  const onSearchBarPress = () => {
    analytics.trackEvent(CX_SEARCH_BAR_CLICKED, {
      screen: "todays_cx",
    });
  };

  return (
    <View style={styles.container} testID={testIds.Todays_Customers}>
      <View style={styles.headerContainer}>
        <View style={styles.header}>
          <TouchableOpacity
            testID={testIds.Navigate_From_Customers_To_My_Shop}
            onPress={() => props.navigation.goBack()}
          >
            <BackArrowIcon />
          </TouchableOpacity>
          <Text style={styles.headerText}>
            {t(`${PATH}/todaysCustomers`)} ({totalCustomers})
          </Text>
        </View>
        <View style={styles.paddingHorizontal}>
          <SearchBar
            testID={testIds.Search_Customers}
            query={query}
            placeholder={t(`${PATH}/placeholder`)}
            handleQueryChange={(value) => {
              setQuery(value);
            }}
            shouldShowIcon={true}
            rightIcon={!query ? <></> : <CloseIcon />}
            clearSearch={true}
            onPressRightIcon={() => {
              setQuery("");
            }}
            onFocus={onSearchBarPress}
          />
        </View>
      </View>
      {query ? (
        <FlatList
          testID={testIds.Scroll_Customers}
          data={data}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          ListEmptyComponent={query && ListEmptyComponent}
          contentContainerStyle={{
            paddingBottom: 120,
            flexGrow: 1,
          }}
        />
      ) : (
        <View>
          <FlatList
            testID={testIds.Scroll_Customers}
            data={notOrderedCustomers}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
            contentContainerStyle={{
              paddingBottom: 120,
              flexGrow: 1,
            }}
            ListEmptyComponent={query && ListEmptyComponent}
            ListFooterComponent={renderOrderedCustomers}
          />
        </View>
      )}
    </View>
  );
};

export default TodaysCustomers;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#E5E5E5",
  },
  headerContainer: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    paddingTop: 16,
    paddingBottom: 16,
    marginBottom: 8,
    elevation: 8,
  },
  header: {
    flexDirection: "row",
    paddingHorizontal: 20,
    alignItems: "center",
  },
  headerText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 16,
    fontWeight: "700",
    marginLeft: 18,
  },
  paddingHorizontal: {
    paddingTop: 20,
    paddingHorizontal: 16,
  },
  noCustomersFound: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 27,
    textAlign: "center",
    marginVertical: 12,
  },
  searchOtherCustomer: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 20,
    color: "rgba(0, 0, 0, 0.56)",
  },
  listEmptyComponentContainer: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  sectionHeader: {
    margin: 16,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: "NotoSansDevanagari-Bold",
  },
});
